import React, {useState, useEffect, useRef} from 'react'
import qs from 'query-string'
import _ from 'lodash'
import { useHistory, useLocation, useParams } from 'react-router-dom'

interface IUseFilters {
    filters: Record<string, any>,
    appliedFilter: Record<string, any>,
    setFilter(values: Record<string, any>, apply?: boolean, replaceAll?: boolean): void
    applyFilter(afterApplyFilter?: Function): void
    cancelFilter(args: string[]): void
    initializeFilters(): void

}

export function useFilters(): IUseFilters {
    let history = useHistory();
    let location = useLocation();
    const urlParams = useParams() as Record<string, any>; 

	const [filters, setFilters] = useState(qs.parse(location.search))
	const [appliedFilter, setAppliedFilter] = useState(qs.parse(location.search));



	const isFirstLoad = useRef(false)
    useEffect(() => {
        isFirstLoad.current = true
    }, [])
	useEffect(() => {
        if(isFirstLoad.current){
            isFirstLoad.current = false
        }else{
            if (_.isEmpty(appliedFilter) && _.isEmpty(location.search)) {
                history.push(`${location.pathname}?_page=1`)
            } else {
                history.push(`${location.pathname}?${qs.stringify(_.omit(appliedFilter, '_page', '_per_page'))}`)
            }
        }        
        // history.push({pathname: location.pathname, search: qs.stringify(appliedFilter)})
	}, [JSON.stringify(appliedFilter)])
    
    useEffect(() => {
        // @ts-ignore
        if (window.initializeSwiper) {
            // @ts-ignore
            window.initializeSwiper()
        }
    })
    

	const applyFilter = (afterApplyFilter) => {
		setAppliedFilter(filters)
        // setFilters({})
        if (afterApplyFilter) {
            afterApplyFilter()
        }
	}

	const cancelFilter = (args) => {
        if (_.isArray(args)) {
            setFilters(_.omit(filters,  args))
            setAppliedFilter(_.omit(appliedFilter,  args))
        }
	}

	const initializeFilters = () => {
		setAppliedFilter({})
		setFilters({})
    }

    const setFilter = (values, apply=false, replaceAll = false) => {
        const newFilters = _.cloneDeep(filters)
        _.forOwn(values, (value, key) => {
            if (_.has(filters, key)) {
                if (_.isArray(value) && !replaceAll) {
                    _.forEach(value, (v) => {
                        if (_.includes(newFilters[key], v)) {
                            _.remove(newFilters[key], e => e === v)
                        } else {
                            Array.isArray(newFilters[key]) ? (newFilters[key] as string[]).push(v) : newFilters[key] = [newFilters[key], v]
                        }

                    })
                } else {
                    newFilters[key] = value
                }
            } else {
                newFilters[key] = value
            }

        })
        if (apply) {
            setAppliedFilter(newFilters)
            setFilters(newFilters)
        } else {
            setFilters(newFilters)
        }

    }

	return { filters: {...appliedFilter, ...filters},appliedFilter, setFilter, applyFilter, cancelFilter, initializeFilters }
}


declare global {
	interface Window {
        jQuery: Function
        elementorFrontend: {
            init: Function
        }
	}
}



/**
 * @description we use this hooks to initiaize the plugins of elementor
 */
export function useWpPlugins(): void {

    let history = useHistory()

    useEffect(() => {
        // check if we user eact-router for navigation (nor refresh or relead the browser)
        if (history.action !== 'POP') {
            setTimeout(() => {
                if (window.jQuery) {
                    const selectors = ['header', 'footer'].map((element) => `[data-elementor-type="${element}"] div.elementor-menu-toggle`).join(', ')
                    window.jQuery(selectors).unbind('click');
                    window.jQuery(() => window.elementorFrontend.init())
                }
            }, 3000)
        }
    }, [])
}

/**
 * @description we use this hook for handling scroll-to-top
 * @param {boolean} willScroll we pass it when our component has to display a list over multiple pages   
 */

export function useScroll(willScroll?: boolean) {
    const history = useHistory()

    useEffect(() => {
        // deactivate it when the map-side-list is hidden and there's only the map.
        const map = document.querySelector('.products-map-container.w-full')
        if (history.action !== 'POP' && !map) {
            window.scroll({
                top: 0,
                left: 0,
            })
        }
    }, [willScroll])
}